import { InputGroup } from './native'

export default function Group(props){
    return <InputGroup {...props} />
}